import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileObject } from '@it2go/types';
import { InputFileBtnComponent } from '../input-file-btn/input-file-btn.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-input-logo',
    templateUrl: './input-logo.component.html',
    styleUrls: ['./input-logo.component.scss'],
    imports: [
    InputFileBtnComponent,
    NgClass
],
})
export class InputLogoComponent {
    @Input() imageUrl: string | null = '';
    @Input() owner = '';
    @Output() uploaded = new EventEmitter<FileObject>();

    emitUploaded(file: FileObject) {
        this.uploaded.emit(file);
    }
}
